var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTmLogoBlue(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 518.04 55.39",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#053b5c;}.cls-2{fill:#00c85b;}.cls-3{fill:#ff3000;}.cls-4{fill:#ff9e00;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "teamlytica_blue_@4x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_4",
    "data-name": "Layer 4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M16.3,11.78H0V.92H44.37V11.78H28.08V54.47H16.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M131.27.54h10.86l23,53.93H152.77l-4.9-12H125.22l-4.89,12h-12Zm12.39,31.52-7.11-17.37-7.12,17.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M173.26.92H186L200,23.56,214.11.92h12.7V54.47h-11.7v-35L200,42.38h-.3L184.81,19.74V54.47H173.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M240.59.92h11.78V43.76h26.7V54.47H240.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M292.69,33.36,272.11.92h13.77l12.78,21.5,13-21.5h13.39L304.47,33.13V54.47H292.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M347.35,11.78h-16.3V.92h44.37V11.78H359.13V54.47H347.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M384.14.92h11.78V54.47H384.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M407,27.85V27.7C407,12.47,418.47,0,434.92,0,445,0,451.06,3.37,456,8.26l-7.5,8.65c-4.13-3.75-8.33-6.05-13.69-6.05-9,0-15.53,7.5-15.53,16.68v.16c0,9.18,6.35,16.83,15.53,16.83,6.12,0,9.87-2.45,14.08-6.28l7.5,7.58c-5.51,5.89-11.63,9.56-22,9.56C418.7,55.39,407,43.23,407,27.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M484.23.54h10.86L518,54.47H505.73l-4.9-12H478.18l-4.89,12h-12Zm12.39,31.52-7.11-17.37-7.12,17.37Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 56.27,
    y: 0.59,
    width: 41.8,
    height: 10.68
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 56.27,
    y: 43.97,
    width: 41.95,
    height: 10.68
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 56.27,
    y: 21.94,
    width: 32.95,
    height: 10.68
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTmLogoBlue);
export default __webpack_public_path__ + "static/media/tm_logo_blue.9d7bd332aafc7e52100fd3782620c069.svg";
export { ForwardRef as ReactComponent };